import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _excluded = ["children", "extra", "onClick"];
var _templateObject, _templateObject2;
import styled from 'styled-components';
import { GlobalStyle } from "./utils.js";
import { ButtonBase } from "./Button.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Warpper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  gap: 10px;\n  align-items: stretch;\n"])));
var Input = styled.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  border: 1px solid var(--color-border-result-code);\n  border-radius: 6px;\n  padding: 6px 8px;\n  min-width: 220px;\n"])));
export var InputButton = _ref => {
  var {
      children,
      extra,
      onClick
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Warpper, {
    children: [/*#__PURE__*/_jsx(GlobalStyle, {}), /*#__PURE__*/_jsx(Input, _extends({}, props)), /*#__PURE__*/_jsx(ButtonBase, {
      onClick: onClick,
      style: {
        padding: '0px 10px'
      },
      children: children || 'Search'
    }), extra]
  });
};